import { BaseConfig } from '../ServiceConfig';

export interface LocationConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.LocationServiceConfigData';
  url: string;
}

export const LocationConfigurationFields: (keyof LocationConfiguration)[] = [
  'url',
];

export const BlankLocationConfiguration: LocationConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.LocationServiceConfigData',
} as LocationConfiguration;
